// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipLabel_tooltip__egxtB","required":"tooltipLabel_required__549M+"};